export default __webpack_public_path__ + "static/media/NIAS0240.34I-31025_-17662_0.db297a9b.jpg";